import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import { Embryo } from '@/rtk-query.gql';

import { EditEmbryoForm } from '../edit-embryo-form';
import { EditEmbryoFormValues } from '../edit-embryo-form/schema';

type EmbryoData = Embryo;

type EditEmbryoDialogProps = {
  visible: boolean;
  onHide: () => void;
  onSave: (data: EditEmbryoFormValues) => void;
  embryo?: EmbryoData;
  readOnly?: boolean;
  readOnlyReason?: string;
};

export const EditEmbryoDialog = ({
  visible,
  onHide,
  onSave,
  embryo,
  readOnly = false,
  readOnlyReason,
}: EditEmbryoDialogProps) => {
  const { t } = useTranslation();
  const handleSubmit = (values: EditEmbryoFormValues) => {
    onSave(values);
    onHide();
  };

  return (
    <Dialog
      header={readOnly ? t('embryo.viewEmbryo') : t('embryo.editEmbryo')}
      visible={visible}
      onHide={onHide}
      modal
      className="w-[1000px] max-w-[95vw]"
    >
      <EditEmbryoForm
        visible={visible}
        onCancel={onHide}
        onSubmit={handleSubmit}
        embryo={embryo}
        readOnly={readOnly}
        readOnlyReason={readOnlyReason}
      />
    </Dialog>
  );
};
